import { Link } from "react-router-dom";
import { Mail, Phone, Instagram, MapPin, Globe } from "lucide-react";
import { Logo } from "./Logo";
import { openCookieSettings } from "./CookieBanner";
import { CONTACT, useLink, useT } from "@/lib/i18n";

export const Footer = () => {
  const t = useT();
  const link = useLink();
  const links = [
    ["services", t.nav.services], ["moving", t.nav.indMoving], ["living", t.nav.indLiving],
    ["business", t.nav.business], ["contact", t.nav.contact], ["privacy", t.footer.privacy], ["cookies", t.footer.cookies],
  ];
  const contacts = [
    [Mail, CONTACT.email, `mailto:${CONTACT.email}`, "footer-email"],
    [Phone, CONTACT.phone, CONTACT.phoneHref, "footer-phone"],
    [Instagram, CONTACT.instagram, CONTACT.instagramHref, "footer-instagram"],
    [Globe, CONTACT.website, "/", "footer-website"],
  ];
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-forest text-ivory">
      <svg className="pointer-events-none absolute -top-px left-0 w-full text-ivory" viewBox="0 0 1440 60" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 0h1440v20c-240 40-480 40-720 10S240-10 0 30z" fill="currentColor" />
      </svg>
      <div className="container-x grid gap-12 pb-10 pt-24 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo to={link("home")} light testid="footer-logo" className="h-24 w-auto" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ivory/80">{t.footer.tagline}</p>
          <p className="mt-6 font-display text-xl">Ayşegül Karaali</p>
          <p className="mt-1 flex items-center gap-2 text-sm text-ivory/75"><MapPin size={15} /> {t.footer.location}</p>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow eyebrow-light">{t.footer.contactTitle}</p>
          <ul className="mt-6 space-y-4">
            {contacts.map(([Icon, label, href, id]) => (
              <li key={id}>
                <a href={href} data-testid={id} className="group flex items-center gap-3 text-[15px] text-ivory/90 hover:text-gold-light" {...(href.startsWith("http") ? { target: "_blank", rel: "noopener noreferrer" } : {})}>
                  <span className="flex h-9 w-9 items-center justify-center rounded-full border border-ivory/20 transition-colors group-hover:border-gold-light"><Icon size={15} /></span>
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow eyebrow-light">{t.footer.linksTitle}</p>
          <ul className="mt-6 space-y-3">
            {links.map(([k, l]) => (
              <li key={k}><Link to={link(k)} data-testid={`footer-link-${k}`} className="link-u text-[15px] text-ivory/90 hover:text-gold-light">{l}</Link></li>
            ))}
            <li><button onClick={openCookieSettings} data-testid="footer-cookie-settings" className="link-u text-[15px] text-ivory/90 hover:text-gold-light">{t.footer.cookieSettings}</button></li>
          </ul>
        </div>
      </div>
      <div className="container-x flex flex-col gap-3 border-t border-ivory/15 py-7 text-xs text-ivory/70 md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} Home in Slovenia · Ayşegül Karaali. {t.footer.rights}</p>
        <p data-testid="footer-legal-placeholder">{t.footer.legal}</p>
      </div>
    </footer>
  );
};
